import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    base: 'flex w-full flex-col gap-2',
    link: 'text-m-bold hover:bg-bg-items-white/85 focus:hover:bg-bg-items-white/85 max-lg:bg-bg-items-white/85 flex items-center justify-between gap-2 p-6 transition-colors duration-150',
    icon: 'shrink-0 lg:hidden'
  },
  variants: {
    active: {
      true: {
        link: 'bg-bg-items-white hover:bg-bg-items-white focus:bg-bg-items-white'
      }
    }
  }
});
